module.exports = __webpack_public_path__ + "img/banner_zngylyq.56b14a60.png";